import * as RadixDialog from '@radix-ui/react-dialog';
import { ArrowLeftIcon, MagnifyingGlassIcon } from '@phosphor-icons/react';
import React from 'react';

import { Input } from '../input/Input';

export interface IBulkActionsDialogProps {
  isOpen: boolean;
  onClose: () => void;
  selectionCount: number;
  isBusy?: boolean;
  enableSearch?: boolean;
  searchValue?: string;
  onSearchChange?: (v: string) => void;
  searchPlaceholder?: string;
  countLabel?: (n: number) => string;
  children: React.ReactNode;
}

const defaultCountLabel = (n: number) => `${n} geselecteerd`;

export const BulkActionsDialog: React.FC<IBulkActionsDialogProps> = (props) => {
  const {
    isOpen,
    onClose,
    selectionCount,
    isBusy,
    enableSearch,
    searchValue = '',
    onSearchChange,
    searchPlaceholder = 'Zoek een actie...',
    countLabel = defaultCountLabel,
    children,
  } = props;

  return (
    <RadixDialog.Root open={isOpen} onOpenChange={(open) => !open && !isBusy && onClose()}>
      <RadixDialog.Portal>
        <RadixDialog.Overlay className="dialog-overlay" />
        <RadixDialog.Content
          className="dialog-content"
          style={{ maxWidth: '32rem', padding: 0 }}
          onInteractOutside={(evt) => {
            if (isBusy) evt.preventDefault();
          }}
        >
          {isOpen && (
            <>
              <div className="flex items-center justify-between px-4 py-3 border-b border-border">
                <button
                  type="button"
                  onClick={onClose}
                  disabled={isBusy}
                  aria-label="Sluit"
                  className="flex items-center justify-center w-8 h-8 rounded-full hover:bg-surface-hover disabled:cursor-default"
                >
                  <ArrowLeftIcon className="w-4 h-4" />
                </button>
                <RadixDialog.Title asChild>
                  <span className="px-3 py-1 rounded-full bg-neutral-subtle text-xs text-fg-secondary">
                    {countLabel(selectionCount)}
                  </span>
                </RadixDialog.Title>
                <span className="w-8" />
              </div>

              {enableSearch && onSearchChange && (
                <div className="px-4 pt-3">
                  <Input
                    type="text"
                    value={searchValue}
                    onChange={onSearchChange}
                    placeholder={searchPlaceholder}
                    iconLeft={<MagnifyingGlassIcon className="input-icon" />}
                  />
                </div>
              )}

              <div className="overflow-y-auto p-2 max-h-[60vh] flex flex-col gap-0.5">{children}</div>
            </>
          )}
        </RadixDialog.Content>
      </RadixDialog.Portal>
    </RadixDialog.Root>
  );
};
